export default {
    segmenthorConfig: {
        radioGroup: ['Tracker', 'Combined', 'Network']
    },
    timers: {
        DEFAULT_TIME_UPLOAD_END: 400,
        TOGGLE_TIMEOUT: 10000
    }
};

